import React, { useCallback } from 'react';
import { useParams } from 'react-router';
import Form, { SubmitType } from '../../../../../components/form';
import css from './create-warehouse-modal-form.module.css';
import { useWarehouseContext } from '../../deals/warehouse-context';
import { useHistory } from 'react-router-dom';
import Modal from '../../../../../components/modals/modal';
import {
  defaultValues,
  useWarehouseForm,
  warehouseSchema,
} from './use-warehouse-form';
import { useCreateFooter } from './use-footer';
import { useTranslation } from 'react-i18next';
import Warehouse from '../../../../../interfaces/warehouse';
import { route } from '../../../../../services/utils';
import { useService } from '../../../../../services/services';
import { UseFormReturn } from 'react-hook-form';
import DealType from '../../../../../enums/deal-type';

export default function CreateWarehouseModalForm({
  formMethods = null,
  setWarehouseId = null,
  className = '',
}: {
  formMethods?: UseFormReturn;
  setWarehouseId?: (value: string) => void;
  className?: string;
}) {
  const { t } = useTranslation();
  const { dealType, farmId } = useParams<{
    dealType: DealType;
    farmId: string;
  }>();
  const history = useHistory();
  const { warehouseService } = useService();
  const { setOpenModal } = useWarehouseContext();
  const warehouseBody = useWarehouseForm();
  const warehouseFooter = useCreateFooter(true, setOpenModal);

  const submitWareHouse = useCallback<SubmitType<Warehouse>>(
    (form: any) => {
      if (typeof form.address === 'object') {
        form.address = form.address?.value;
      }
      return [
        warehouseService.store(farmId, form),
        (response: Warehouse) => {
          setWarehouseId(response.id);
          if (dealType === DealType.moved) {
            formMethods.setValue('to_warehouse_id', {
              value: response?.id,
              label: response?.name,
            });
          } else {
            let productWarehouses = formMethods.getValues('product_warehouses');

            productWarehouses[0].warehouse_id = {
              value: response?.id,
              label: response?.name,
            };
            formMethods.setValue('product_warehouses', productWarehouses);
          }

          setOpenModal(false);
          history.push(route(null, { farmId, id: response.id }));
        },
      ];
    },

    [
      warehouseService,
      farmId,
      history,
      setOpenModal,
      formMethods,
      setWarehouseId,
      dealType,
    ]
  );

  return (
    <Modal
      visible={true}
      onClose={() => setOpenModal(false)}
      className={`${css['modalWareHouse']} ${className}`}
      buttons={null}
      overlayClassName="overlay-light"
      overlayColor={'rgba(0, 42, 88, 0)'}
      body={
        <Form
          mode="create"
          title={t('pages.warehouse.warehouses.create-warehouse')}
          body={warehouseBody}
          footer={warehouseFooter}
          values={defaultValues}
          submit={submitWareHouse}
          schema={warehouseSchema({ department_pvd_nr: true })}
        />
      }
    />
  );
}
